export enum AllergyTypeEnum {
    Medication = 1,
    Class = 2,
}
